<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->

    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/ruike/pending/receipt/detail/page" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item class="noborder" :label="$t('dairukudanhao')">
            <el-input disabled v-model="$attrs.receipt.no"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('kucunzuzhi')">
            <el-input disabled v-model="$attrs.receipt.inventoryOrg"></el-input>
          </el-form-item>

          <el-form-item>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('biaoqianmingxi', scope.row,'70%')">
              {{$t('biaoqianmingxi')}}
            </el-button>
          </el-col>
        </el-row>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
      :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'biaoqianmingxi'">
        <div class="dialog-scroller">
          <label_details :labelDetails="yt.editObj" :receiptDetails="$attrs.receipt"></label_details>
        </div>
        <span slot="footer" class="dialog-footer">
						<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
						<el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST','/web/customer/create')" type="primary">
							{{$t('baocun')}}
						</el-button>
					</span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
  import label_details from '@@/pages/web/production_management/pending_receipt_rk/label_details'
  export default {
    name: 'web_production_management_pending_receipt_rk_label_details',
    components: {
      label_details
    },
    data() {
      return {
        materialIdlist: [],
        materialIds: null,
        planIdList: [],
        planId: null,
        columns: [
          {
            label: 'xuhao',
            prop: 'serialNo'
          },
          {
            label: 'shengchangongdanhao',
            prop: 'woNo',
            width: 130
          },
          {
            label: 'ERPgongdanhao',
            prop: 'erpNo',
            width: 130
          },
          {
            label: 'chanpinbianma',
            prop: 'material.code',
            width: 130
          },
          {
            label: 'chanpinmingcheng',
            prop: 'material.name'
          },
          {
            label: 'wangongshuliang',
            prop: 'completedQuantity',
            width: 150
          },
          {
            label: 'picihao',
            prop: 'batchNo',
            width: 130
          },
          {
          	label: 'caozuo',
          	type: 'slot',
          	width: 130,
          	fixed: 'right'
          },
        ]
      };
    },

    created() {
      setTimeout(() => {
        this.yt.conditions = {
          orderBy: 'serialNo asc',
          pendingReceiptId: this.$attrs.receipt.id,
        };
        this.yt.get(1);
      }, 300);
    },
    methods: {
      selectionChange(items) {
        this.planIdList = items.map(item => {
          return item.id;
        });
        this.planId = items
          .map(item => {
            return item.no;
          })
          .join(',');
      },
      getItems(items) {
        this.materialIdlist = items;

        for (let i = 0; i < this.materialIdlist.length; i++) {
          this.materialId = this.materialIdlist[i]['id'];
        }
        console.log('this.materialId', this.materialId);
      }
    }
  };
</script>
